export default __webpack_public_path__ + "static/media/info.0282aec1.svg";